import React from 'react'

export const LayoutContext = React.createContext([{}, () => { }])